import { IObserverDetailParams } from "@/models";
import { computeParams } from "@/utils/to-params";
import axiosClient from "@/libs/axiosClient";
import exp from "node:constants";
import { downloadXls } from "@/utils/download-xls";

enum API_URL {
  subaccounts = "/api/v1/pools/sub_account/observer_link/sub_accounts/",
  chart = "/api/v1/pools/sub_account/observer_link/create/",
  exportXls = "/api/v1/pools/sub_account/observer_link/export_xls/",
  detail = "/api/v1/pools/sub_account/observer_link/detail/",
}
export const getDetailWatcherLink = (
  token: string,
  params?: IObserverDetailParams,
) => {
  return axiosClient
    .get(API_URL.detail + `${token}/`, { params: params ?? {} })
    .then((res) => res.data);
};
export const getWatcherLinkSubAccounts = (token: string) => {
  return axiosClient.get(API_URL.subaccounts + `${token}/`);
};

export const exportXlsObserver = (
  token: string,
  params: { [key in string]: string },
) => {
  return axiosClient
    .get(API_URL.exportXls + `${token}/`, {
      params: params,
      responseType: "blob",
    })
    .then((response: any) => {
      downloadXls(response);
    });
};
